import { useLayout } from '@Queries/useLayout';

const useLayoutChatIcons = () => {
  const layout = useLayout();

  return { isReady: layout.isSuccess, links: layout.data?.onlineConsultation };
};

export default useLayoutChatIcons;
